import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Breadcrumbs from '../common/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="h-screen flex bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <div className="hidden md:flex md:flex-col">
        <Sidebar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <div className="py-6">
            <div
              className={`max-w-none mx-auto transition-all duration-200 ${
                isSidebarCollapsed ? 'px-4 sm:px-6 md:px-8' : 'px-4 sm:px-6 md:px-8 max-w-7xl'
              }`}
            >
              <Breadcrumbs />
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
